import React from 'react'
import { decodeHTML } from 'scripts/lib/utils'
import imageBanner from 'scripts/config/ImageBanner'
import FeaturedBanner from 'scripts/components/featured/FeaturedBanner'
import locale, {getLang} from 'shared/i18n/react'

function CategoryImage(props) {
  return (
    <picture className="featured-wrapper-image-container featured-wrapper-container-category">
      <source
        media="(min-width: 35.125rem)"
        srcSet={`${props.imageUrl}?&s=1954x500&e=t 1954w,
                 ${props.imageUrl}?&s=1400x500&e=t 1400w`}
        sizes="100vw"
      />
      <img
        srcSet={
          `${props.imageUrl}?&s=1400x933&e=t 1400w,
           ${props.imageUrl}?&s=555x370&e=t 555w,
           ${props.imageUrl}?&s=358x245&e=t 358w,
           ${props.imageUrl}?&s=900x600&e=t 900w`
        }
        sizes="100vw"
        className="responsive-img"
      />
    </picture>
  )
}

export const ListingsHeader = ({name, image, routes}) => {
  if (!name) { return null }
  const slug = routes.params.slug
  const lang = getLang()
  let url = (imageBanner[lang][slug]) ? imageBanner[lang][slug] : imageBanner[lang]['default']
  const imageUrl = url
  // Note: The headingContent should  come from the json result
  const headingContent = decodeHTML(name)
  const imageComponent = <CategoryImage imageUrl={imageUrl} />

  return (
    <FeaturedBanner wrapperClass="featured-banner" imageComponent={imageComponent} featuredMetaClass="featured-meta-default">
      <div className="featured-meta-wrapper">
        <div className="featured-meta-container">
          <div className="title list-featured-subtitle">{locale.general.explore}</div>
          <h2 className="margin-none list-featured-title uppercase">
            {headingContent}
          </h2>
        </div>
      </div>
    </FeaturedBanner>
  )
}



// WEBPACK FOOTER //
// ./assets/js/helpers/ListingsHeader.jsx